import React from 'react'

const ThankYou: React.FC = () => {
  return (
    <div className='container py-20 d-flex align-items-center justify-content-center'>
      <div className='card w-100' style={{maxWidth: 520}}>
        <div className='card-body text-center py-15'>
          <h2 className='fw-bold mb-5'>Thank You</h2>
          <div className='fs-5 text-gray-700'>Your application has been submitted.</div>
          <div className='text-muted mt-2'>A confirmation email has been sent to you.</div>
        </div>
      </div>
    </div>
  )
}

export default ThankYou


